<!--
 * @Author: your name
 * @Date: 2021-04-20 10:14:10
 * @LastEditTime: 2021-04-20 13:35:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-henan-oms-facade-SIT\src\components\EcMetaLayout\src\index.vue
-->
<template>
  <div class="ec-meta flex-space-between ">
    <div class="ec-operate">
      <slot name="left"></slot>
    </div>
    <el-button-group>
      <slot name="right"></slot>
    </el-button-group>
  </div>
</template>
<script>
export default {
  name: 'EcMeta'
}
</script>
<style lang="scss" scoped>
.ec-meta {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/EcMetaLayout/src/index.vue